import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './FactBox.module.scss'

interface FactBoxProps {
  children?: React.ReactNode
  className?: string
}

export const FactBox: FC<FactBoxProps> = ({ children, className }: FactBoxProps) => (
  <div className={clsx(className, styles.factBox)}>{children}</div>
)
